import { render } from "./OfficeTable.vue?vue&type=template&id=4a9719bb&scoped=true"
import script from "./OfficeTable.vue?vue&type=script&lang=js"
export * from "./OfficeTable.vue?vue&type=script&lang=js"

import "./OfficeTable.vue?vue&type=style&index=0&id=4a9719bb&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9719bb"]])

export default __exports__